import { styled } from '@mui/system';
import { Box, Typography } from '@mui/material';
import {
  SectionHeading,
  SectionSubtext,
  StepNumber,
  StepTitle,
  DescriptionText,
  ChecklistText,
} from '../../styles';
import { colors } from '../../../../../constants/theme';

export const JourneyHeading = styled(SectionHeading)(({ theme }) => ({
  letterSpacing: '-.5px',
}));

export const JourneySubtext = styled(SectionSubtext)(({ theme }) => ({
  marginTop: '14px',
  fontWeight: 400,
  letterSpacing: '.5px',
  [theme.breakpoints.down('sm')]: {
    fontSize: '16px',
  },
  [theme.breakpoints.between('sm', 'md')]: {
    fontSize: '18px',
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '22px',
  },
}));

export const StepsContainer = styled(Box)({
  maxHeight: 'fit-content',
  width: '100%',
});

export const StepWrapper = styled(Box)({
  position: 'relative',
  marginTop: '20px',
  width: '100%',
});

export const StepCardContent = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isEven',
})(({ theme, isEven }) => ({
  display: 'flex',
  alignItems: 'center',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    textAlign: 'center',
    width: '100%',
  },
  [theme.breakpoints.up('md')]: {
    flexDirection: isEven ? 'row-reverse' : 'row',
    textAlign: 'left',
  },
}));

export const StepContentWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isEven',
})(({ theme, isEven }) => ({
  height: 'auto',
  marginTop: 'auto',
  marginBottom: 'auto',
  [theme.breakpoints.down('sm')]: {
    padding: '20px 16px',
  },
  [theme.breakpoints.between('sm', 'md')]: {
    padding: '24px 24px',
  },
  [theme.breakpoints.up('md')]: {
    padding: isEven ? '8px 50px 0px 50px' : '0px 40px 0px 90px',
  },
}));

export const JourneyStepNumber = styled(StepNumber)(({ theme }) => ({
  fontWeight: 325,
  marginBottom: '12px',
  [theme.breakpoints.down('sm')]: {
    fontSize: '18px',
    marginBottom: '8px',
  },
  [theme.breakpoints.between('sm', 'md')]: {
    fontSize: '20px',
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '24px',
  },
}));

export const JourneyStepTitle = styled(StepTitle)(({ theme }) => ({
  fontSize: '32px',
  marginBottom: '10px',
  textTransform: 'capitalize',
  [theme.breakpoints.down('lg')]: {
    fontSize: '28px',
  },
  [theme.breakpoints.down('md')]: {
    fontSize: '26px',
    marginBottom: '8px',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '14px',
  },
}));

export const JourneyDescriptionText = styled(DescriptionText, {
  shouldForwardProp: (prop) => prop !== '$hasSubtitle',
})(({ theme, $hasSubtitle }) => ({
  lineHeight: '22px',
  [theme.breakpoints.down('sm')]: {
    fontSize: '14px',
    lineHeight: '20px',
    marginBottom: $hasSubtitle ? '6px' : '12px',
  },
  [theme.breakpoints.between('sm', 'md')]: {
    fontSize: '16px',
    marginBottom: $hasSubtitle ? '8px' : '14px',
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '18px',
    marginBottom: $hasSubtitle ? '14px' : '13px',
  },
}));

export const ChecklistContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
  [theme.breakpoints.down('md')]: {
    alignItems: 'center',
  },
  [theme.breakpoints.up('md')]: {
    alignItems: 'flex-start',
  },
}));

export const JourneyChecklistText = styled(ChecklistText)(({ theme }) => ({
  lineHeight: '26px',
  [theme.breakpoints.down('sm')]: {
    fontSize: '14px',
    lineHeight: '22px',
  },
}));

export const CTAButtonContainer = styled(Box)(({ theme }) => ({
  margin: '0 auto',
}));

export const JourneyExtraDataContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: '10px',
  marginTop: '15px',
  flexWrap: 'wrap',
  justifyContent: 'start',
  [theme.breakpoints.down('md')]: {
    justifyContent: 'center',
  },
}));

export const JourneyExtraData = styled(Typography)(({ theme }) => ({
  fontSize: '13px',
  fontWeight: 400,
  color: colors.text,
  lineHeight: 1.5,
  textAlign: 'left',
  border: '1px solid #B4B2B2',
  borderRadius: '50px',
  padding: '10px 20px',
  whiteSpace: 'nowrap',
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  flexDirection: 'row',
  [theme.breakpoints.down('sm')]: {
    fontSize: '12px',
    padding: '8px 16px',
    gap: '8px',
    '& img': {
      width: '16px',
      height: '16px',
    },
  },
}));
